import { Environment } from '../api';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const EnvironmentSelectOptions: ISelectOption[] = [
  {
    id: Environment.production,
    value: Environment.production,
    displayName: Environment.production,
    filterType: FilterTypesEnum.Environment,
  },
  {
    id: Environment.development,
    value: Environment.development,
    displayName: Environment.development,
    filterType: FilterTypesEnum.Environment,
  },
  {
    id: Environment.test,
    value: Environment.test,
    displayName: Environment.test,
    filterType: FilterTypesEnum.Environment,
  },
];
